import $ from 'jquery'
import Swiper from 'swiper/bundle'

new Swiper('.hero__slider', {
  slidesPerView: 1,
  spaceBetween: 15,
  freeMode: true,
  freeModeSticky: true,
  navigation: {
    nextEl: '.hero__nav--next',
    prevEl: '.hero__nav--prev',
  },
  breakpoints: {
    766: {
      slidesPerView: 'auto',
    },
    992: {
      spaceBetween: 30,
    },
  },
})

$('.hero__nav--scroll').click(function () {
  $('html, body').animate(
    {
      scrollTop: $('.cc-block').eq(0).offset().top - 50,
    },
    250
  )
})
